// import React, { useEffect, useRef, useState } from "react";
// import { Modal, Button } from "react-bootstrap";

// import Navbar from "../component/Navbar.js";
// import "../css/profile.css";
// import { Checkuser, EditName, getUserProfile } from "../api/hitapi.js";
// import Footer from "../component//Footer.js";
// import Cookies from "js-cookie";
// import { BiSolidEdit } from "react-icons/bi";
// import OwlCarousel from "react-owl-carousel";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";
// import {images} from '../jsonData/images.js'


// const Profile = () => {


//   const [record, setRecord] = useState([]);
//   const [currentPoint, setcurrentPoint] = useState([]);
//   const owlCarouselRef = useRef(null);
//   const [modalShow, setModalShow] = useState(false);
//   const [profileImage,setProfileImage] = useState('');
//   const [updateImage,setUpdateImage] = useState(null);
//   const [InputText,setInputText] = useState('');
//   const [message, setMessage] = useState('');
//   const [data,setData] = useState([]);
//   const [totalPoints, setTotalPoints] = useState(0);
//   const [totalSpins, setTotalSpins] = useState(0);
//   const [totalWins, setTotalWins] = useState(0);
//   const ani = Cookies.get("ani");

//   // useEffect(() => {
//   //   setData(images);
//   //   Checkuser(ani).then((response) => {
//   //     console.log("Api Response",response);
//   //     setRecord(response.data.sumScore);
//   //     setcurrentPoint(response.data.Points.points);
//   //     setProfileImage(response.data.Points.imageName);
//   //     setInputText(response.data.Points.name);

//   //     Cookies.set("point", response.data.Points.points);
//   //     Cookies.set("score", response.data.sumScore);
//   //   });

//   //   getUserProfile(ani).then((res) => {
//   //     console.log("UserProfile Response", res);
//   //     setTotalPoints(res.totalPoints);
//   //     setTotalSpins(res.totalSpins);
//   //     setTotalWins(res.totalWins);
//   //   }).catch((err) => {
//   //     console.error("Error fetching user profile", err);
//   //   });

//   //   if (owlCarouselRef.current) {
//   //     window.dispatchEvent(new Event("resize"));
//   //   }
//   // }, []);

 
// //   useEffect(() => {
// //   const fetchProfileData = async () => {
// //     try {
// //       setData(images);

// //       // User Details API
// //       const userResponse = await Checkuser(ani);

// //       console.log("Api Response", userResponse);

// //       setRecord(userResponse?.data?.sumScore || 0);
// //       setcurrentPoint(userResponse?.data?.Points?.points || 0);
// //       setProfileImage(userResponse?.data?.Points?.imageName || "");
// //       setInputText(userResponse?.data?.Points?.name || "Player");

// //       Cookies.set("point", userResponse?.data?.Points?.points || 0);
// //       Cookies.set("score", userResponse?.data?.sumScore || 0);

// //       // Profile Stats API
// //       const profileResponse = await getUserProfile(ani);

// //       console.log("UserProfile Response", profileResponse);

// //       setTotalPoints(profileResponse?.totalPoints || 0);
// //       setTotalSpins(profileResponse?.totalSpins || 0);
// //       setTotalWins(profileResponse?.totalWins || 0);
// //     } catch (error) {
// //       console.error("Profile Error:", error);

// //       setTotalPoints(0);
// //       setTotalSpins(0);
// //       setTotalWins(0);
// //     }
// //   };

// //   fetchProfileData();

// //   if (owlCarouselRef.current) {
// //     window.dispatchEvent(new Event("resize"));
// //   }
// // }, [ani]);




// useEffect(() => {
//   const fetchProfileData = async () => {
//     try {
//       setData(images);

//       // User Details API
//       const userResponse = await Checkuser(ani);
//       console.log("Api Response", userResponse);

//       setRecord(userResponse?.data?.sumScore || 0);
//       setcurrentPoint(userResponse?.data?.Points?.points || 0);
//       setInputText(userResponse?.data?.Points?.name || "Player");

//       Cookies.set("point", userResponse?.data?.Points?.points || 0);
//       Cookies.set("score", userResponse?.data?.sumScore || 0);

//       // Profile Stats API
//       const profileResponse = await getUserProfile(ani);
//       console.log("UserProfile Response", profileResponse);
//       setProfileImage(profileResponse?.profileImage || "");

//       setTotalPoints(profileResponse?.totalPoints || 0);
//       setTotalSpins(profileResponse?.totalSpins || 0);
//       setTotalWins(profileResponse?.totalWins || 0);

//     } catch (error) {
//       console.error("Profile Error:", error);
//       setTotalPoints(0);
//       setTotalSpins(0);
//       setTotalWins(0);
//     }
//   };

//   if (ani) {
//     fetchProfileData();
//   }

//   if (owlCarouselRef.current) {
//     window.dispatchEvent(new Event("resize"));
//   }
// }, [ani]);
//   const options = {
//     center: false,
//     items: 4,
//     loop: true,
//     margin: 5,
//     stagePadding: 15,
//     autoplay: false,
//     autoPlaySpeed: 300,
//     autoplayTimeout: 1000,
//     responsive: {
//       0: {
//         items: 2,
//       },
//       400: {
//         items: 2,
//       },
//       600: {
//         items: 3,
//       },
//       700: {
//         items: 3,
//       },
//       1000: {
//         items: 4,
//       },
//     },
//   };

//   const number = Cookies.get("ani");
//   const score = Cookies.get("score");
//   const point = Cookies.get("point");

//   const [hide, setHide] = useState(false);


//   const handleModalShow = () => {
//     setModalShow(true);
   
//   };

//   const handleModalClose = () => {
//     setModalShow(false);
//   };

//   const handleChange = event => {
//     setMessage(event.target.value);

//     console.log('value is:', event.target.value);
//   };



//   const handleClick = event => {
//     event.preventDefault();
    
//     console.log("UpdateImage",updateImage);
//     // 👇️ value of input field
//     console.log('UserName 👉️', message);
//     if(message ===null || message === undefined || message === ' ' || message === '' ) 
//     {
//       setMessage("Player");
//     }
//     EditName(ani,message,updateImage).then((response)=>{
//       console.log("response",response.data.name);
      
//       setProfileImage(response.data.imageName);
//       setInputText(response.data.name);
//       console.log("Name",InputText);
//     });
//     setModalShow(false);
//   };


//   const handleData=(id)=>{
//     data.map((item)=>{
//       if(item.id===id)
//       {
//         setUpdateImage(item.images);
//       }
//     })
//   }

//   return (
//     <>
//       {/* <!-- Start Navbar Area --> */}

//       <Navbar />
//       {/* <!-- Search Overlay --> */}
//       <div class="search-overlay">
//         <div class="d-table">
//           <div class="d-table-cell">
//             <div class="search-overlay-layer"></div>
//             <div class="search-overlay-layer"></div>
//             <div class="search-overlay-layer"></div>

//             <div class="search-overlay-close">
//               <span class="search-overlay-close-line"></span>
//               <span class="search-overlay-close-line"></span>
//             </div>

//             <div class="search-overlay-form">
//               <form>
//                 <input
//                   type="text"
//                   class="input-search"
//                   placeholder="Search here..."
//                 />
//                 <button type="submit">
//                   <i class="flaticon-search-1"></i>
//                 </button>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* <!-- End Search Overlay --> */}

//       {/* <!-- Start Page Title Area --> */}
//       <section class="page-title-area page-title-bg1">
//         <div class="container">
//           <div class="page-title-content img-box">
//             <img src={profileImage} class="player-image" alt="image" />
//             <div onClick={() => handleModalShow()} class="edit-box">
//               <BiSolidEdit />
//             </div>
//             <br />
//             {/* <h1 title="Sarah Taylor" style={{ color: "white" }}>
//               {InputText}
//             </h1> */}
//             <span class="sub-title">{number}</span>

          
//           </div>
//         </div>
//       </section>
//       {/* <!-- End Page Title Area --> */}

//       {/* <!-- Start Player Details Area --> */}
//      <section className="player-details-area ptb-100">
//   <div className="container">
//     <div className="player-details-desc">
//       <ul className="player-meta">
//         <li>
//           <div className="icon">
//             <i className="flaticon-network"></i>
//           </div>
//           Total Points
//           <span>{totalPoints}</span>
//         </li>

//         <li>
//           <div className="icon">
//             <i className="flaticon-game-computer"></i>
//           </div>
//           Total Spins
//           <span>{totalSpins}</span>
//         </li>

//         <li>
//           <div className="icon">
//             <i className="flaticon-3d"></i>
//           </div>
//           Total Wins
//           <span>{totalWins}</span>
//         </li>
//       </ul>
//     </div>
//   </div>
// </section>
//       {/* <!-- End Player Details Area --> */}

//       <Footer />

//       {/* Button to trigger the modal */}
//       {/* Vertically Centered Bootstrap Modal */}
//       <Modal centered show={modalShow} onHide={handleModalClose}>
//         <div class="m-h"><Modal.Header  closeButton>
//           <Modal.Title>Edit Profile</Modal.Title>
//           </Modal.Header>
//         </div>
//         <Modal.Body>
//           {/* Modal content */}          
//           <div class="edit-profile vt-profile-modal">
//             <div class="profile-inner">
//             <div class="edit-img-box">
//             <OwlCarousel  ref={owlCarouselRef}
//                 className="story owl-carousel owl-theme"
//                 {...options} >
//                   {data.map((item)=>{
//                     // console.log("data",item.images);
//                    return (
//                     <div class="edit-img-box-inner" onClick={()=>{handleData(item.id)}}><img src={item.images} class="player-image" alt="i" /></div>
//                    )
//                   })}
                
              
//             </OwlCarousel>
//             </div>
//               <div class="edit-name-box">
//                 <label>Edit Name</label>
//                 <input  type="text" id="edit-name" onChange={handleChange} placeholder="Edit Name"></input>
//                 <button class="save-btn" onClick={handleClick}>Save</button>
//               </div>
              
//             </div>

//           </div>
//         </Modal.Body>
//         {/* <Modal.Footer>   
//           <div class="m-f">      
//           <Button variant="secondary" onClick={handleModalClose}>
//             Close
//           </Button>
//           </div> 
//         </Modal.Footer> */}
//       </Modal>
      
//     </>
//   );
// };

// export default Profile;





// import React, { useEffect, useRef, useState } from "react";
// import { Modal } from "react-bootstrap";

// import Navbar from "../component/Navbar.js";
// import "../css/profile.css";
// import { Checkuser, EditName, getUserProfile } from "../api/hitapi.js";
// import Footer from "../component/Footer.js";
// import Cookies from "js-cookie";
// import { BiSolidEdit } from "react-icons/bi";
// import OwlCarousel from "react-owl-carousel";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";
// import { images } from "../jsonData/images.js";

// const Profile = () => {
//   const owlCarouselRef = useRef(null);

//   const [record, setRecord] = useState(0);
//   const [currentPoint, setcurrentPoint] = useState(0);
//   const [modalShow, setModalShow] = useState(false);
//   const [profileImage, setProfileImage] = useState("");
//   const [selectedImage, setSelectedImage] = useState(null); // selected avatar URL
//   const [InputText, setInputText] = useState("");
//   const [message, setMessage] = useState("");
//   const [data, setData] = useState([]);
//   const [totalPoints, setTotalPoints] = useState(0);
//   const [totalSpins, setTotalSpins] = useState(0);
//   const [totalWins, setTotalWins] = useState(0);

//   const ani = Cookies.get("ani");
//   const number = Cookies.get("ani");

//   const options = {
//     center: false,
//     items: 4,
//     loop: true,
//     margin: 5,
//     stagePadding: 15,
//     autoplay: false,
//     autoPlaySpeed: 300,
//     autoplayTimeout: 1000,
//     responsive: {
//       0:    { items: 2 },
//       400:  { items: 2 },
//       600:  { items: 3 },
//       700:  { items: 3 },
//       1000: { items: 4 },
//     },
//   };

//   // Fetch user + profile stats on mount
//   useEffect(() => {
//     const fetchProfileData = async () => {
//       try {
//         setData(images);

//         // User Details API
//         const userResponse = await Checkuser(ani);
//         console.log("Api Response", userResponse);

//         setRecord(userResponse?.data?.sumScore || 0);
//         setcurrentPoint(userResponse?.data?.Points?.points || 0);
//         setInputText(userResponse?.data?.Points?.name || "Player");

//         Cookies.set("point", userResponse?.data?.Points?.points || 0);
//         Cookies.set("score", userResponse?.data?.sumScore || 0);

//         // Profile Stats API
//         const profileResponse = await getUserProfile(ani);
//         console.log("UserProfile Response", profileResponse);

//         setProfileImage(profileResponse?.profileImage || "");
//         setTotalPoints(profileResponse?.totalPoints || 0);
//         setTotalSpins(profileResponse?.totalSpins || 0);
//         setTotalWins(profileResponse?.totalWins || 0);
//       } catch (error) {
//         console.error("Profile Error:", error);
//         setTotalPoints(0);
//         setTotalSpins(0);
//         setTotalWins(0);
//       }
//     };

//     if (ani) fetchProfileData();

//     if (owlCarouselRef.current) {
//       window.dispatchEvent(new Event("resize"));
//     }
//   }, [ani]);

//   const handleModalShow = () => {
//     setSelectedImage(profileImage); // pre-select current profile image
//     setMessage(InputText);          // pre-fill current name
//     setModalShow(true);
//   };

//   const handleModalClose = () => {
//     setModalShow(false);
//   };

//   // Select avatar from carousel
//   const handleAvatarSelect = (imageUrl) => {
//     setSelectedImage(imageUrl);
//   };

//   // Save — sends msisdn, profileName, profileUrl as query params
//   const handleClick = async (event) => {
//     event.preventDefault();

//     const finalName = (!message || message.trim() === "") ? "Player" : message.trim();
//     const finalUrl  = selectedImage || profileImage;

//     console.log("Saving:", { ani, finalName, finalUrl });

//     try {
//       // EditName(msisdn, profileName, profileUrl)
//       const response = await EditName(ani, finalName, finalUrl);
//       console.log("Edit Response", response.data);

//       setProfileImage(response.data.profileUrl || finalUrl);
//       setInputText(response.data.profileName  || finalName);
//     } catch (err) {
//       console.error("Edit Error", err);
//     }

//     setModalShow(false);
//   };

//   return (
//     <>
//       <Navbar />

//       {/* Search Overlay */}
//       <div className="search-overlay">
//         <div className="d-table">
//           <div className="d-table-cell">
//             <div className="search-overlay-layer" />
//             <div className="search-overlay-layer" />
//             <div className="search-overlay-layer" />
//             <div className="search-overlay-close">
//               <span className="search-overlay-close-line" />
//               <span className="search-overlay-close-line" />
//             </div>
//             <div className="search-overlay-form">
//               <form>
//                 <input type="text" className="input-search" placeholder="Search here..." />
//                 <button type="submit">
//                   <i className="flaticon-search-1" />
//                 </button>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Page Title / Profile Header */}
//       <section className="page-title-area page-title-bg1">
//         <div className="container">
//           <div className="page-title-content img-box">
//             <img src={profileImage} className="player-image" alt="profile" />
//             <div onClick={handleModalShow} className="edit-box">
//               <BiSolidEdit />
//             </div>
//             <br />
//             <span className="sub-title">{number}</span>
//           </div>
//         </div>
//       </section>

//       {/* Player Stats */}
//       <section className="player-details-area ptb-100">
//         <div className="container">
//           <div className="player-details-desc">
//             <ul className="player-meta">
//               <li>
//                 <div className="icon">
//                   <i className="flaticon-network" />
//                 </div>
//                 Total Points
//                 <span>{totalPoints}</span>
//               </li>
//               <li>
//                 <div className="icon">
//                   <i className="flaticon-game-computer" />
//                 </div>
//                 Total Spins
//                 <span>{totalSpins}</span>
//               </li>
//               <li>
//                 <div className="icon">
//                   <i className="flaticon-3d" />
//                 </div>
//                 Total Wins
//                 <span>{totalWins}</span>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </section>

//       <Footer />

//       {/* Edit Profile Modal */}
//       <Modal centered show={modalShow} onHide={handleModalClose}>
//         <div className="m-h">
//           <Modal.Header closeButton>
//             <Modal.Title>Edit Profile</Modal.Title>
//           </Modal.Header>
//         </div>

//         <Modal.Body>
//           <div className="edit-profile vt-profile-modal">
//             <div className="profile-inner">

//               {/* Selected avatar preview */}
//               <div className="selected-avatar-preview" style={{ textAlign: "center", marginBottom: "12px" }}>
//                 {selectedImage && (
//                   <img
//                     src={selectedImage}
//                     alt="selected"
//                     className="player-image"
//                     style={{
//                       width: "80px",
//                       height: "80px",
//                       borderRadius: "50%",
//                       border: "3px solid #7b5ea7",
//                       objectFit: "cover",
//                     }}
//                   />
//                 )}
//                 {/* Profile URL display */}
//                 {selectedImage && (
//                   <p
//                     style={{
//                       fontSize: "11px",
//                       color: "#999",
//                       marginTop: "6px",
//                       wordBreak: "break-all",
//                       padding: "0 10px",
//                     }}
//                   >
//                     {selectedImage}
//                   </p>
//                 )}
//               </div>

//               {/* Avatar carousel */}
//               <div className="edit-img-box">
//                 <OwlCarousel
//                   ref={owlCarouselRef}
//                   className="story owl-carousel owl-theme"
//                   {...options}
//                 >
//                   {data.map((item) => (
//                     <div
//                       key={item.id}
//                       className="edit-img-box-inner"
//                       onClick={() => handleAvatarSelect(item.images)}
//                       style={{
//                         cursor: "pointer",
//                         border: selectedImage === item.images ? "3px solid #7b5ea7" : "3px solid transparent",
//                         borderRadius: "50%",
//                         padding: "2px",
//                       }}
//                     >
//                       <img src={item.images} className="player-image" alt="avatar" />
//                     </div>
//                   ))}
//                 </OwlCarousel>
//               </div>

//               {/* Name input + save */}
//               <div className="edit-name-box">
//                 <label>Edit Name</label>
//                 <input
//                   type="text"
//                   id="edit-name"
//                   value={message}
//                   onChange={(e) => setMessage(e.target.value)}
//                   placeholder="Edit Name"
//                 />
//                 <button className="save-btn" onClick={handleClick}>
//                   Save
//                 </button>
//               </div>

//             </div>
//           </div>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

// export default Profile;




import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";

import Navbar from "../component/Navbar.js";
import "../css/profile.css";
import { Checkuser, EditName, getUserProfile } from "../api/hitapi.js";
import Footer from "../component/Footer.js";
import Cookies from "js-cookie";
import { BiSolidEdit } from "react-icons/bi";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { images } from "../jsonData/images.js";

const Profile = () => {
  const owlCarouselRef = useRef(null);

  const [record, setRecord] = useState(0);
  const [currentPoint, setcurrentPoint] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [profileImage, setProfileImage] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [InputText, setInputText] = useState("");
  const [message, setMessage] = useState("");
  const [data, setData] = useState([]);
  const [totalPoints, setTotalPoints] = useState(0);
  const [totalSpins, setTotalSpins] = useState(0);
  const [totalWins, setTotalWins] = useState(0);

  const ani = Cookies.get("ani");
  const number = Cookies.get("ani");

  const options = {
    center: false,
    items: 4,
    loop: true,
    margin: 5,
    stagePadding: 15,
    autoplay: false,
    autoPlaySpeed: 300,
    autoplayTimeout: 1000,
    responsive: {
      0:    { items: 2 },
      400:  { items: 2 },
      600:  { items: 3 },
      700:  { items: 3 },
      1000: { items: 4 },
    },
  };

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        setData(images);

        const userResponse = await Checkuser(ani);
        console.log("Api Response", userResponse);

        setRecord(userResponse?.data?.sumScore || 0);
        setcurrentPoint(userResponse?.data?.Points?.points || 0);
        setInputText(userResponse?.data?.Points?.name || "Player");

        Cookies.set("point", userResponse?.data?.Points?.points || 0);
        Cookies.set("score", userResponse?.data?.sumScore || 0);

        const profileResponse = await getUserProfile(ani);
        console.log("UserProfile Response", profileResponse);

        setProfileImage(profileResponse?.profileImage || "");
        setTotalPoints(profileResponse?.totalPoints || 0);
        setTotalSpins(profileResponse?.totalSpins || 0);
        setTotalWins(profileResponse?.totalWins || 0);
      } catch (error) {
        console.error("Profile Error:", error);
        setTotalPoints(0);
        setTotalSpins(0);
        setTotalWins(0);
      }
    };

    if (ani) fetchProfileData();

    if (owlCarouselRef.current) {
      window.dispatchEvent(new Event("resize"));
    }
  }, [ani]);

  const handleModalShow = () => {
    setSelectedImage(profileImage);
    setMessage(InputText);
    setModalShow(true);
  };

  const handleModalClose = () => {
    setModalShow(false);
  };

  const handleAvatarSelect = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const handleClick = async (event) => {
    event.preventDefault();

    const finalName = (!message || message.trim() === "") ? "Player" : message.trim();
    const finalUrl  = selectedImage || profileImage;

    console.log("Saving:", { ani, finalName, finalUrl });

    try {
      const response = await EditName(ani, finalName, finalUrl);
      console.log("Edit Response", response.data);

      setProfileImage(response.data.profileUrl || finalUrl);
      setInputText(response.data.profileName  || finalName);
    } catch (err) {
      console.error("Edit Error", err);
    }

    setModalShow(false);
  };

  return (
    <>
      <Navbar />

      {/* Search Overlay */}
      <div className="search-overlay">
        <div className="d-table">
          <div className="d-table-cell">
            <div className="search-overlay-layer" />
            <div className="search-overlay-layer" />
            <div className="search-overlay-layer" />
            <div className="search-overlay-close">
              <span className="search-overlay-close-line" />
              <span className="search-overlay-close-line" />
            </div>
            <div className="search-overlay-form">
              <form>
                <input type="text" className="input-search" placeholder="Search here..." />
                <button type="submit">
                  <i className="flaticon-search-1" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Profile Header */}
      <section className="page-title-area page-title-bg1">
        <div className="container">
          <div className="page-title-content img-box">

            {/* Avatar + edit button */}
            <div style={{ position: "relative", display: "inline-block" }}>
              <img
                src={profileImage}
                className="player-image"
                alt="profile"
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  border: "3px solid rgba(255,255,255,0.4)",
                  objectFit: "cover",
                  display: "block",
                  margin: "0 auto",
                }}
              />
            </div>

            {/* Player name */}
            <h3
              style={{
                color: "white",
                fontWeight: "700",
                fontSize: "18px",
                margin: "10px 0 4px",
              }}
            >
              {InputText || "Player"}
            </h3>

            {/* MSISDN */}
            <span className="sub-title" style={{ fontSize: "14px", opacity: 0.75 }}>
              {number}
            </span>

            {/* Edit button — icon + text */}
            <div style={{ marginTop: "14px" }}>
              <button
                onClick={handleModalShow}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "7px",
                  background: "rgba(255,255,255,0.12)",
                  border: "1px solid rgba(255,255,255,0.3)",
                  borderRadius: "8px",
                  padding: "8px 18px",
                  color: "white",
                  fontSize: "14px",
                  fontWeight: "700",
                  cursor: "pointer",
                  backdropFilter: "blur(4px)",
                  transition: "background 0.2s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.22)")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.12)")}
              >
                <BiSolidEdit style={{ fontSize: "16px" }} />
                Edit Profile
              </button>
            </div>

          </div>
        </div>
      </section>

      {/* Player Stats */}
      <section className="player-details-area ptb-100">
        <div className="container">
          <div className="player-details-desc">
            <ul className="player-meta">
              <li>
                <div className="icon">
                  <i className="flaticon-network" />
                </div>
                Total Points
                <span>{totalPoints}</span>
              </li>
              <li>
                <div className="icon">
                  <i className="flaticon-game-computer" />
                </div>
                Total Spins
                <span>{totalSpins}</span>
              </li>
              <li>
                <div className="icon">
                  <i className="flaticon-3d" />
                </div>
                Total Wins
                <span>{totalWins}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <Footer />

      {/* Edit Profile Modal */}
      <Modal centered show={modalShow} onHide={handleModalClose}>
        <div className="m-h">
          <Modal.Header closeButton>
            <Modal.Title>Edit Profile</Modal.Title>
          </Modal.Header>
        </div>

        <Modal.Body>
          <div className="edit-profile vt-profile-modal">
            <div className="profile-inner">

              {/* Selected avatar preview */}
              <div
                style={{
                  textAlign: "center",
                  marginBottom: "16px",
                  padding: "14px",
                  background: "rgba(123,94,167,0.06)",
                  borderRadius: "12px",
                  border: "1px solid rgba(123,94,167,0.15)",
                }}
              >
                {selectedImage && (
                  <img
                    src={selectedImage}
                    alt="selected"
                    className="player-image"
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                      border: "3px solid #7b5ea7",
                      objectFit: "cover",
                      marginBottom: "8px",
                    }}
                  />
                )}
                <p
                  style={{
                    fontSize: "11px",
                    color: "#999",
                    margin: "0",
                    wordBreak: "break-all",
                    padding: "0 6px",
                  }}
                >
                  {selectedImage || "No image selected"}
                </p>
              </div>

              {/* Avatar carousel */}
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: "700",
                  color: "#7b5ea7",
                  marginBottom: "8px",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                }}
              >
                Choose Avatar
              </p>
              <div className="edit-img-box">
                <OwlCarousel
                  ref={owlCarouselRef}
                  className="story owl-carousel owl-theme"
                  {...options}
                >
                  {data.map((item) => (
                    <div
                      key={item.id}
                      className="edit-img-box-inner"
                      onClick={() => handleAvatarSelect(item.images)}
                      style={{
                        cursor: "pointer",
                        border: selectedImage === item.images
                          ? "3px solid #7b5ea7"
                          : "3px solid transparent",
                        borderRadius: "50%",
                        padding: "2px",
                        transition: "border 0.15s",
                      }}
                    >
                      <img src={item.images} className="player-image" alt="avatar" />
                    </div>
                  ))}
                </OwlCarousel>
              </div>

              {/* Name input + save */}
              <div className="edit-name-box" style={{ marginTop: "16px" }}>
                <label
                  style={{
                    fontSize: "12px",
                    fontWeight: "700",
                    color: "#7b5ea7",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                    display: "block",
                    marginBottom: "6px",
                  }}
                >
                  Display Name
                </label>
                <input
                  type="text"
                  id="edit-name"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Enter your name"
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    borderRadius: "8px",
                    border: "1px solid rgba(123,94,167,0.3)",
                    fontSize: "15px",
                    fontWeight: "600",
                    outline: "none",
                    marginBottom: "12px",
                  }}
                />
                <button
                  className="save-btn"
                  onClick={handleClick}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "10px 24px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    cursor: "pointer",
                  }}
                >
                  <BiSolidEdit style={{ fontSize: "16px" }} />
                  Save Changes
                </button>
              </div>

            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Profile;
